<!--两个图片效果对比组件-->
<template>
  <div ref="imgContainer" class="img-container" @mousemove="mouseMove" @touchmove="touchMove">
    <div style="height: 100%;overflow: hidden;">
      <!--style="background-image: url('../assets/imgs/toolbox/image_cutout_later.png')" -->
      <div class="original-image" :style="{'background-image': 'url('+imgO+')'}"></div>
      <div class="separator" :style="{ 'left': separatorX + 'px' }">
      <img src="@/assets/imgs/home/image_boundary.png" alt="" style="margin-left:-10px;">
      </div>
      <!--style="background-image: url('../assets/imgs/toolbox/image_cutout_artwork.png')" -->
      <div class="handled-image" :style="{'left': separatorX + 'px', 'background-image': 'url('+imgR+')'}"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CompareImage",
    props: ['imgOriginal','imgResult'],
    data () {
      return {
        separatorX: 0,
        separatorWidth: 0,
        containerX: 0,
        containerWidth: 0,
        imgO: this.imgOriginal,
        imgR: this.imgResult
      }
    },
    mounted() {
      const {left, width } = this.$refs.imgContainer.getBoundingClientRect();
      this.containerX = left;
      this.containerWidth = width;
      this.separatorX = width / 2;
    },
    computed: {
      originWidth() {
        return this.separatorX
      },
      handledWidth() {
        return this.containerWidth - this.originWidth - this.separatorWidth
      },
    },
    methods: {
      mouseMove(e) {
        const min = 0, max = this.containerWidth - this.separatorWidth;
        // 当前坐标值
        const result = e.clientX - this.containerX;

        if (result <= max && result >= min) {
          this.separatorX = result
        } else if (result < min) {
          this.separatorX = min
        } else {
          this.separatorX = max
        }
      },
      touchMove(e) {
        const min = 0, max = this.containerWidth - this.separatorWidth;
        // 当前坐标值
        const result = e.changedTouches[0].clientX - this.containerX;

        if (result <= max && result >= min) {
          this.separatorX = result
        } else if (result < min) {
          this.separatorX = min
        } else {
          this.separatorX = max
        }
      },
    },

  }
</script>

<style scoped>
  .img-container {
    /*width: 678px;*/
    /*height: 470px;*/
    background: #c0ccda;
    position: relative;
    overflow: hidden;
  }

  .separator {
    position: absolute;
    top: 0;
    left: 0;
    width: 2px;
    height: 100%;
    /* background: #4C75FF; */
    z-index: 3;
  }

  .separator:before, .separator:after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    width: 0;
    height: 0;
    border: 8px solid transparent;
  }

  /* .separator:before {
    right: 3px;
    margin-right: 2px;
    background:#4C75FF ;
    border-right-color: #fff;
    border-radius: 50% 0 0 50%;
}

  .separator:after {
    left: 3px;
    border-left-color: #4C75FF;
  } */

  .original-image {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    /*background-image: url('../assets/imgs/toolbox/image_cutout_later.png');*/
    background-position: center center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position-x: 0;

  }

  .handled-image {
    height: 100%;
    top: 0;
    left: 50%;
    right: 0;
    position: absolute;
    /*background-image: url('../assets/imgs/toolbox/image_cutout_artwork.png');*/
    background-position: center center;
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position-x: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/CompareImage.vue